import { render, staticRenderFns } from "./ExternalIncentiveBlock.vue?vue&type=template&id=4d01dca8&scoped=true"
import script from "./ExternalIncentiveBlock.vue?vue&type=script&lang=js"
export * from "./ExternalIncentiveBlock.vue?vue&type=script&lang=js"
import style0 from "./ExternalIncentiveBlock.vue?vue&type=style&index=0&id=4d01dca8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d01dca8",
  null
  
)

export default component.exports